<template>
  <div class="designHomeModular">
    <navBarNoLab :onIndex="0"></navBarNoLab>
    <div class="designContent">
      <!-- banner-start -->
      <div id="scrollTg1" class="banner">
        <div class="banerCont"><img src="./images/banner_font.png" width="1230px" height="413px" alt=""></div>
        <div class="labelCont" v-if="bannerInfo">
          <div class="labelItem" v-for="(item,index) in bannerInfo.contListDataes" :key="index">
            <img v-if="item.image" :src="item.image[0].url" width="32px" alt=""> 
            {{item.title}}<i>{{index == 0 ? numberA : index == 1 ? numberB : numberC }}<span v-show="index == 0">+ </span><span v-show="index == 3">+ </span><span v-show="index == 1">W+ </span></i>
          </div>
        </div>
      </div>
      <!-- banner-end -->
      <!-- 项目列表-start -->
      <div id="scrollTg2" class="screen objectList" style="padding-top: 70px;min-height:1025px">
        <div class="centent" v-if="objectListdata && objectListdata.length > 0">
          <!-- <HomeTitle :title="`${objectListdata.length}个真实项目，扩充经验积累，助你进击设计师`" subTitle='五大设计方向，紧跟市场需求，遴选热门项目，给你广阔的未来'></HomeTitle> -->
          <HomeTitle :title="`24+个真实项目，扩充经验积累，助你进击设计师`" subTitle='五大设计方向，紧跟市场需求，遴选热门项目，给你广阔的未来'></HomeTitle>
          <div class="cont">
            <div class="typeList">
              <span :class="{act:objAct == index}" @click="fliterObjListHandle(item, index, 'obj')" v-for="(item, index) in typeList" :key="index">{{item}}</span>
            </div>
            <!-- <div class="objectItems"> -->
              <swiper :options="swiperUiOption" style="width:calc(100%);" :key="objAct" class="objectItems">
                <swiper-slide v-for="(items, index) in swiperDataSet(objectList)" class="itemCont" :key="'sw'+index">
                  <div class="itemList" v-for="(item, ind) in items"  :key="'it'+ind" @click="goDetails(item)">
                      <div class="showImg">
                        <img :src="item.image[0].url" width="100%" alt="">
                        <div class="but"><span>立即查看</span></div>
                      </div>
                      <div class="infoCont">
                        <div class="tit" v-if="item.lableList">
                          {{item.title}}
                          <span v-for="(it, i) in item.lableList.split('、')" :key="i">{{it}}</span>
                        </div>
                        <div class="des">{{ item.desc }}</div>
                      </div>
                  </div>
                </swiper-slide>
              </swiper>
              <div class="uiSwiper">
                <div class="swiper-ui-button-prev" slot="button-prev"></div>
                <div class="swiper-ui-pagination" slot="pagination"></div>
                <div class="swiper-ui-button-next" slot="button-next"></div>
              </div>
          </div>
        </div>
      </div>
      <!-- 项目列表-end -->
      <div id="scrollTg3" class="screen studentWorks" style="min-height:875px" >
        <HomeTitle title="往期学员作品，在这里看到成长后的你" subTitle='丰富的项目经验，杰出的项目作品集，让你在众多求职者中脱颖而出'></HomeTitle>
        <div class="cont" v-if="studentListdata && studentListdata.length > 0">
          <div class="typeList">
            <span :class="{act:stAct == index}" @click="fliterObjListHandle(item, index, 'st')" v-for="(item, index) in studentTypeList" :key="'obj'+index">{{item}}</span>
          </div>
          <div class="objectItems">
            <Wiper :data="studentList" @openBigImg="openBigImg" speed="4" :key="stAct"></Wiper>
          </div>
          <div class="objectItems">
            <Wiper :data="studentList2" @openBigImg="openBigImg" speed="1" :key="stAct"></Wiper>
          </div>
        </div>
      </div>
      <div id="scrollTg4" class="screen fifthScreen">
        <HomeTitle title="职场老手，教你分辨“好”项目课程" subTitle='能够分辨，才能学到真项目，才能找到好工作'></HomeTitle>
        <div class="content" :class="{isShow: showTagD}">
          <div class="leftCont">
            <div class="titCont">
                <img src="./images/logo_wit.png" width="190px" alt="">
            </div>
            <div class="rowCont">
              <div class="rowList"  v-for="(item, index) in contrastData.leftCont" :key="index">
                <div class="title">{{item.title}}</div>
                <div class="desc">{{item.desc}}</div>
                <div class="itemIcon">
                  <p><img :src="item.icon" width="26px" alt=""></p>
                  <p>{{item.label}}</p>
                </div>
              </div>
            </div>
            </div>
          <div>
          <div class="ritCont">
              <div class="titCont">
                  部分机构
              </div>
              <div class="rowCont">
                <div class="rowList" v-for="(item, index) in contrastData.rightCont" :key="index">
                  <div class="title">{{item.title}}</div>
                  <div class="desc">{{item.desc}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="scrollTg5" class="screen sixthScreen">
        <HomeTitle title="真场景教学-给学员多维度赋能" subTitle='还原真实工作场景，引导学生探究性学习 抬高学生分析和解决实际问题的能力'></HomeTitle>
        <div class="centent">
          <div class="sixTop" :class="{isShow: showTagE}">
            <img src="./images/bg_six_top.png" width="100%" alt="">
            <div class="cont">
              <div class="tit">
                <img src="./images/icon_six_tit.png" width="40" height="31.72" alt="">
                <span>什么是场景式教学？</span>
              </div>
              <div class="desc">
                打破传统填鸭式教学，基于企业真实工作场景，依托项目研发流程，进行项目课程设计+讲授，让学员在真实工作场景中，引导学生探究性学习，掌握实用的设计技能，并抬高学生分析和解决实际问题的能力。
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="scrollTg51" class="screen sixthScreen">
        <div class="centent">
          <div class="sixCen" :class="{isShow: showTagE1}">
            <div class="tit">想要成为「设计师」，要具有项目迭代升级的能力</div>
            <div class="cenCont">
              <img src="./images/img_cont.jpg" width="100%" alt="">
            </div>
          </div>
        </div>
      </div>
      <div id="scrollTg52" class="screen sixthScreen">
        <div class="sixBut"  :class="{isShow: showTagE2}">
          <div class="tit">想要成为「出色设计师」，要明晰设计思路、精进设计方法，学会触类旁通</div>
          <div class="sixRollCont">
            <div class="centent">
              <swiper :options="swiperUiScrollOption">
                  <swiper-slide v-for="(item, index) in sixscrollData" :key="index">
                    <div class="items">
                      <div class="info">
                        <div class="name">{{item.info.name}}</div>
                        <ul class="desc">
                          <li v-for="(it, ind) in item.info.list" :key="'ds'+ind">{{it}}</li>
                        </ul>
                      </div>
                      <div class="bigImg">
                        <img :src="item.bigImage" width="100%" alt="">
                      </div>
                    </div>
                  </swiper-slide>
              </swiper>
              <div class="uiScrollSwiper">
                <div class="swiper-ui-scroll-button-prev" slot="button-prev"></div>
                <div class="swiper-ui-scroll-pagination" slot="pagination"></div>
                <div class="swiper-ui-scroll-button-next" slot="button-next"></div>
              </div>
              <!-- <div class="swiper-ui-scroll-pagination"></div> -->
            </div>
          </div>
        </div>
      </div>
      <div id="scrollTg6" class="screen sevenScreen">
        <HomeTitle title="学员项目实战，学习效果可见" subTitle='每个校区、每个班级、每个学员所做项目、所产生的作品都与众不同'></HomeTitle>
        <div class="centent" :class="{isShow: showTagF}" style="margin-bottom:60px;">
           <div class="vsCont">
             <div class="vsLeft">
               <img src="./images/img_lt.png" alt="">
               <ul>
                 <li>拿出出色的作品集，找一份高“新”且发展好的工作 </li>
                 <li>老师及时指导学员在项目进程中存在的种种问题 </li>
                 <li>营造良好班级氛围，提出色教学服务 </li>
                 <li>确保每个项目美观度及完整性、可行性 </li>
                 <li>完整经历项目流程，适应工作节奏，积累工作经验</li>
               </ul>
             </div>
             <div class="vsIcon"><img src="./images/img_vs.png" width="100px" alt=""></div>
             <div class="vsRt">
               <ul>
                 <li>作品雷同，面试尴尬且困难</li>
                 <li>盲目练习，缺乏老师系统化指导</li>
                 <li>学习氛围较差，没有良性竞争</li>
                 <li>结果不可控，部分学员无法完成整个项目</li>
                 <li>分散的内容设计，无法将知识与工作串联</li>
               </ul>
               <img src="./images/img_rt.png" alt="">
             </div>
           </div>
           
        </div>
      </div>
      <div id="scrollTg61" class="screen sevenScreen" style="padding-top:0">
        <div class="centent" :class="{isShow: showTagF1}" style="padding-top:0; margin:0 auto;"> 
           <div class="processCont">
             <div class="tit">实战项目流程</div>
             <div class="proCont">
                <div class="item" v-for="(item, index) in processDate" :key="index">
                  <div class="tTit">{{item.tit}}</div>
                  <div class="lab" v-for="(it, ind) in item.item" :key="`${ind+1}${index}`">{{it}}</div>
                </div>
             </div>
           </div>        
        </div>
      </div>
      <div id="scrollTg62" class="screen sevenScreen" style="padding-top:0; display:none">
        <div class="centent" :class="{isShow: showTagF2}" style="padding-top:0;">
           <div class="videoListCont">
             <div class="tit">学员项目实战，保证学习效果</div>
              <div class="vidContent">
                  <div class="vidbox">
                      <div class="topVidA">
                        <div class="vidListItem">
                          <img src="./images/bg_video1.png" width="100%" alt="">
                          <div class="play">
                            <img src="./images/icon_play.png" width="20px"  @click="handleVideo('https://v.itheima.net/pip-java-index/UdNxWO.mp4')">
                            <div class="tite">广州Java146期学员</div> 
                            <div class="subt">探花交友项目实战答辩</div>
                          </div>
                        </div>
                        <div class="vidListItem">
                          <img src="./images/bg_video2.png" width="100%" alt="">
                          <div class="play">
                            <img src="./images/icon_play.png" width="20px"  @click="handleVideo('https://v.itheima.net/pip-java-index/Th100t.mp4')">
                            <div class="tite">上海Java148期学员</div> 
                            <div class="subt">传智健康项目实战答辩</div>
                          </div>
                        </div>
                      </div>
                      <div class="topVidB">
                        <div class="vidListItem">
                          <img src="./images/bg_video3.png" width="100%" alt="">
                          <div class="play">
                            <img src="./images/icon_play.png" width="20px"  @click="handleVideo('https://v.itheima.net/pip-java-index/qo2qcN.mp4')">
                            <div class="tite">天津Java149期学员</div> 
                            <div class="subt">探花交友项目实战答辩</div>
                          </div>
                        </div>
                        <div class="vidListItem">
                          <img src="./images/bg_video5.png" width="100%" alt="">
                          <div class="play">
                            <img src="./images/icon_play.png" width="20px"  @click="handleVideo('https://v.itheima.net/pip-java-index/s8Zp5d.mp4')">
                            <div class="tite">天津Java149期学员</div> 
                            <div class="subt">车服管家项目实战答辩</div>  
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="rit vidListItem">
                      <img src="./images/bg_video4.png" width="100%" alt="">
                      <div class="play">
                        <img src="./images/icon_play.png" width="20px" @click="handleVideo('https://v.itheima.net/pip-java-index/DI1AHG.mp4')" alt="">
                        <div class="tite">北京Java150期学员</div> 
                        <div class="subt">SaaS-Export 项目实战答辩</div>
                      </div>
                    </div>
              </div>
            </div>
        </div>
      </div>
      <div id="scrollTg7" class="screen eighthScreen">
        <HomeTitle title="仅讲解高频应用软件，把多的时间留给核心的内容" subTitle='出色设计师的价值精髓是在于设计的思维，工具仅是辅助'></HomeTitle>
        <div class="centent" :class="{isShow: showTagG}">
          <div class="leftCont">
            <div>
              <div class="tit">设计师并不需要学习市面多种软件</div>
              <ul>
                <li><span>同一类软件的使用方法是相通的</span></li>
                <li><span>不在同类软件学习上浪费你的时间</span></li>
                <li><span>20套软件杰出课程-全涵盖，无偿奉送</span></li>
              </ul>
            </div>
          </div>
          <div class="ritCont">
            <img src="./images/img_iconList.png" width="100%" alt="">
          </div>
        </div>
      </div>
      <div id="scrollTg8" class="screen sNine" >
        <div class="centent" :class="{isShow: showTagG}" v-if="ninthScreen">
          <div class="title">{{ninthScreen.title}}</div>
          <div class="cont">
            <div class="items" v-for="(item, index) in ninthScreen.contListDataes" :key="index">
              <div class="info">
                <img v-if="item.image && item.image.length > 0" :src="item.image[0].url" width="40px" alt="">
                <div class="ritInfo">
                  <div class="name">{{item.title}}</div>
                  <div class="time">{{item.subTitle}}</div>
                </div>
              </div>
              <div class="des">
                {{item.desc}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <MenuAdd ref="editMenu"></MenuAdd>
      <!--<MenuListAdd ref="editMenuList"></MenuListAdd> -->
    <el-dialog :visible.sync="dialogVisible" width="80%" >
      <div class="close_ico" @click="() => dialogVisible = false">
        <img src="./images/close.png" width="100%" alt="">
      </div>
      <div class="JavaHomeSwiper">
      <img :src="BigImgUrl" v-if="dialogVisible" width="100%" alt="">
      </div>
    </el-dialog>
    <bottom-widge></bottom-widge>
  </div>
</template>

<script>
import navBarNoLab from "./../../../components/navBarNoLab";
import bottomWidge from "./../../../components/bottomWidge";
import { JavaHome } from "../../../../gqlapi/JavaHome.js";
import HomeTitle from './componentspro/HomeTitle';
import Wiper from './componentspro/Wiper';
import { CutString } from './../../../../utils/tools'
import MenuAdd from "./../../../components/video";
export default {
  name: "uiHome",
  components: {
    navBarNoLab,
    bottomWidge,
    HomeTitle,
    MenuAdd,
    Wiper
  },
  data() {
    return {
      stSrcollNum:0,
      dialogVisible: false,
      bannerInfo:{},
      rollItemIndex:0,
      showDescInd: '',
      swiperUiOption: {
        slidesPerView: 1,
        spaceBetween: 20,
        autoplay:false,
        loop: false,
        loopFillGroupWithBlank: true,
        delay: 3000,
        pagination: {
          el: ".swiper-ui-pagination",
          clickable: true
        },
        navigation: {
          nextEl: ".swiper-ui-button-next",
          prevEl: ".swiper-ui-button-prev",
          disabledClass: "swiper-ui-disabled-class",
        },
      },
      swiperUiScrollOption: {
        // mousewheel: true,
        effect: "fade",
        pagination: {
          el: ".swiper-ui-scroll-pagination",
          clickable: true
        },
        navigation: {
          nextEl: ".swiper-ui-scroll-button-next",
          prevEl: ".swiper-ui-scroll-button-prev",
          disabledClass: "swiper-ui-scroll-disabled-class",
        },
      },
      floatPositTop: 0,
      objectListdata:null,
      objectIndex:0,
      openTag: 0,
      overTag: 0,
      fifthScreen: null,
      sixthScreen: {},
      eighthScreen: null,
      ninthScreen: null,
      bigImageInfo: '',
      itemData: [],
      lodTag2: false,
      lodTag5: false,
      numberA: 24,
      numberB: 5,
      numberC: 5,
      timerNum: {numberA:null, numberB:null, numberC:null,},
      baseInfo:{
        baseInfoTitle1: '',
        baseInfoTitle2: '',
        baseInfoDesc1: '',
        baseInfoDesc2: '',
        pVideoUrl: '',
        videoLogoImage: ''
      },
      contTop: 2500,
      floatTag: 0,
      scrollLeft: 0,
      botTop:0,
      typeList:['全部项目', 'UI/UE', '品牌/平面', '电商/运营', 'C4D/三维'],
      studentTypeList:[ '作品集', 'UI/UE', '品牌/平面','电商/运营', '手绘/插画', 'C4D/三维'],
      objAct:0,
      stAct:0,
      objectList:[],
      contrastData:{
        leftCont:[
          {title:'项目课程适用不同企业发展阶段', desc:'课程「从0到1」的新项目只占20%，「从1到2」的升级项目占比80%，多种项目全覆盖，轻易面对工作中各个阶段企业的种种项目。', icon: '', label:'研发'},
          {title:'并世无两的设计作品，让你面试脱颖而出', desc:'你的作品不在局限于教学项目，而是根据不用业务场景，举一反三，获得具有强烈的个人风格的作品集，告别雷同，打开就业的头道大门。', icon: '', label:'业务'},
          {title:'实战项目流程完整，类型宽泛', desc:'“需求讨论—产品原型—产品设计…项目迭代”，学员作为设计师角色不依赖他人完成项目开发全流程内容，提前进入工作状态，积累项目经验。', icon: '', label:'技术'},
          {title:'仅对主要软件讲解，把课程时间留给核心内容', desc:'仅对主要软件讲解，其他20门同类型软件课程全部无偿赠予,多的不只是数量，而是给予你愈加高含金量的课程。', icon: '', label:'实战'},
        ],
        rightCont:[
          {title:'只做基础项目案例讲解', desc:'「从0到1」已经不符合主流工作场景，但是市面上90%的培训机构还在教授基础项目，学员工作后不知如何对现有项目迭代升级。'},
          {title:'千篇一律的作品集，审美疲劳', desc:'对于讲授项目页面复制粘贴，不关注真实的业务场景，学员作品查重率达到99%，最终淹没在面试的海洋中。'},
          {title:'小项目，只有部分页面', desc:'只讲纯设计部分，不涉及项目其他阶段，不会需求分析，不懂产品定位...造成设计作品缺乏全局化思维及逻辑支撑。'},
          {title:'还拿小众软件当付费课程，浪费课堂时间', desc:'同类型软件、辅助软件不分主次系数都讲，仅软件教学就占了60%的课程时间，对重要知识内容只是浅尝辄止。'}]
      },
      processDate:[
        {tit: '项目需求 分析',item: ['项目需求PRD','竞品分析','头脑风暴','创意设计']},
        {tit: '交互原型 设计',item: ['功能模块分析','业务逻辑分析','线框图设计','交互原型设计']},
        {tit: '产品视觉 设计',item: ['视觉KV','启动图标设计','引导页设计','PC界面设计','移动端设计','其他终端设计','数据可视化']},
        {tit: '视觉规范 制定',item: ['尺寸规范','色彩规范','文字规范','使用规范','动效设计']},
        {tit: '视觉运营 设计',item: ['H5页面设计','广告图设计','物料设计','专题页设计']},
        {tit: '产品上线 与迭代',item: ['高保真交互','切图标注','项目上线','迭代升级']}
      ],
      sixscrollData:[
        {
          info:{
            name: '个性化作品，敲开企业大门的关键',
            list: ['教会你的不只是技术，更是变通的设计思路、精进的设计方法、终身受益的经验技巧', '让你的作品不再是对教学项目机械复刻，而是注入个人灵魂风格的个性化作品', '打造你的专属作品集，成功敲开企业大门']
          },
          bigImage: require('./images/img_six_cont1.png')
        },
        {
          info:{
            name: '详细的需求分析',
            list: ['对设计全流程中的每个节点进行拆解分析，让复杂的事情更简单清晰','学员可以像老师一样庖丁解牛般解决复杂的设计需求']
          },
          bigImage: require('./images/img_six_cont2.png')
        },
        {
          info:{
            name: '丰富的解决方案',
            list: ['结合工作场景里的高频问题，让你设计不用从零开始','方案拿来即用']
          },
          bigImage: require('./images/img_six_cont3.png')
        }
      ],
      studentListdata: [],
      studentList:[],
      studentList2:[],
      showTagA: false,
      showTagB: false,
      showTagC: false,
      showTagD: false,
      showTagE: false,
      showTagE1: false,
      showTagE2: false,
      showTagF: false,
      showTagF1: false,
      showTagF2: false,
      showTagG: false,
      BigImgUrl:'',
    }
  },
  created() {
    this.getJavaHomeDataes();
  },
  mounted() {
    window.addEventListener("scroll", this.scrollHandle);
  },
  methods: {
    // 初始化数据获取
    getJavaHomeDataes(){
        this.$axios.post('/api',{
            operationName: "JavaHome",
            variables:{
                id: 6
            },
            query: JavaHome
        }).then((res) => {
          const data = res.data.data.javaHome;
          this.bannerInfo = data.FirstScreen
          this.ninthScreen = data.eighthScreen
          this.objectListdata = data.objectLists2.filter(it => {if(it.isShow){
            // this.typeListInit(it.labelA, 'a')
            // it.LableB && this.typeListInit(it.LableB, 'b')
            return it
            }})
          this.objectList = this.objectListdata
          this.studentListdata = data.studentWorks
          this.studentList = data.studentWorks
          this.studentList2 = data.studentWorks.slice(data.studentWorks.length/2, data.studentWorks.length)
          this.fliterObjListHandle('作品集', 0, 'st')
        })
        .catch((res) => {
          console.log('JavaHome 请求出错：' + res)
        });
    },
    // 项目分类列表动态处理
    typeListInit(lab, type){
      if (!this.typeList.some(n => lab === n)){
        type == 'b' ? this.typeList.push(lab) : this.typeList.unshift(lab)
      }
    },
    swiperDataSet(data){
      let array = []
      if(data.length <= 8){
          array.push(data)
      } else {
        let arrGroup = []
        let num = 1
        data.forEach((n, ind) => {
          arrGroup.push(n)
          if (num == 8 || data.length == ind+1){
            array.push(arrGroup)
          }
          if (num<8){
            num++ 
          } else if (num == 8){
            num=1
            arrGroup = []
          }
        })
      }
      return array
    },
    // 项目分类切换
    fliterObjListHandle(type, ind, st){
      if (st === 'obj'){
        this.objAct = ind
        if (type == '全部项目'){
          this.objectList = this.objectListdata
        } else {
          this.objectList = this.objectListdata.filter(n => n.labelA == type || n.LableB == type ? n : null)
        }
      } else {
        this.stAct = ind
        const basedata = this.studentListdata.filter(n => n.labelA == type ? n : null)
        this.studentList = basedata.slice(0,basedata.length/2)
        this.studentList2 = basedata.slice(basedata.length/2,basedata.length)
      }
    },
    cutstr(str, ind){
      return CutString(str, ind)
    },
    openFileHandle(url){
      if (url){
        window.open(url, "_blank");
      } else {
        this.dialogVisible = true
      }
    },
    // bannber 数字跳转
    dataCount(obj, num, end, time , ind){
      const i = ind ? ind : 1
      this.timerNum[obj] = setInterval(() => {
        if (num < end){
          num += i
        } else if (num == end) {
          clearInterval(this.timerNum[obj])
        }
        this[obj] = num
      }, time)
    },
    openBigImg(item){
      if(item.icon && item.icon.length > 0){
        this.BigImgUrl = item.icon[0].url
        setTimeout(() => {
          this.dialogVisible = true
        },200)
      }
    },
    // 点击跳转到项目详情 
    goDetails(item) {
      console.log(item)
      if(item.url == null ){
        return false
      }
      window.open(item.url, "_blank");
    },
    openNewUrl(url){
      window.open(url, "_blank");
    },
    // 滚动浮窗
    scrollHandle(){
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft;
        this.floatPositTop = scrollTop
        let aimsId1 = document.querySelector('#scrollTg1');
        let aimsId2 = document.querySelector('#scrollTg2');
        let aimsId3 = document.querySelector('#scrollTg3');
        let aimsId4 = document.querySelector('#scrollTg4');
        let aimsId5 = document.querySelector('#scrollTg5');
        let aimsId51 = document.querySelector('#scrollTg51');
        let aimsId52 = document.querySelector('#scrollTg52');
        let aimsId6 = document.querySelector('#scrollTg6');
        let aimsId61 = document.querySelector('#scrollTg61');
        let aimsId62 = document.querySelector('#scrollTg62');
        let aimsId7 = document.querySelector('#scrollTg7');
        let aimsId8 = document.querySelector('#scrollTg8');
        let baseTag = 100
        this.contTop = baseTag;
        this.scrollLeft = scrollLeft
        if( scrollTop >= baseTag && scrollTop <= aimsId1.offsetTop + baseTag){
          this.showTagA = true
        } else if (scrollTop >= aimsId1.offsetTop + baseTag && scrollTop < aimsId2.offsetTop + baseTag){
          this.showTagB = true
        } else if (scrollTop >= aimsId2.offsetTop + baseTag && scrollTop < aimsId3.offsetTop + baseTag){
          this.showTagC = true
        } else if (scrollTop >= aimsId3.offsetTop + baseTag && scrollTop < aimsId4.offsetTop + baseTag){
          this.showTagD = true
        } else if (scrollTop >= aimsId4.offsetTop + baseTag && scrollTop < aimsId5.offsetTop - 500){
          this.showTagD = true
          this.showTagE = true
        } else if (scrollTop >= aimsId5.offsetTop - 500 && scrollTop < aimsId51.offsetTop + baseTag){
          this.showTagD = true
          this.showTagE = true
          this.showTagE1 = true
        } else if (scrollTop >= aimsId51.offsetTop + baseTag && scrollTop < aimsId52.offsetTop + baseTag){
          this.showTagD = true
          this.showTagE = true
          this.showTagE1 = true
          this.showTagE2 = true
        }else if (scrollTop >= aimsId52.offsetTop + baseTag && scrollTop < aimsId6.offsetTop + baseTag){
          this.showTagF = true
        }else if (scrollTop >= aimsId6.offsetTop + baseTag && scrollTop < aimsId61.offsetTop + baseTag){
          this.showTagF1 = true
        }else if (scrollTop >= aimsId61.offsetTop + baseTag && scrollTop < aimsId62.offsetTop + baseTag){
          this.showTagF2 = true
        } else if (scrollTop >= aimsId62.offsetTop + baseTag && scrollTop < aimsId7.offsetTop + baseTag){
          this.showTagG = true
        } else if (scrollTop >= aimsId8.offsetTop + baseTag){
          this.showTagH = true
        }
    },
    showStandardHandl(ind){
      this.overTag = ind
    },
    colseStandardHandl(){
      this.overTag = this.openTag
    },
  
    handleVideo(url,e) {
      // 由于切换图层原因，传参url为之后一个 所以不可用 将url放到了切换事件中进行更换
      this.baseInfo.pVideoUrl = url
      window.event ? (window.event.cancelBubble = true) : e.stopPropagation();
      this.$refs.editMenu.dialogFormV(this.baseInfo);
    },
    handleVideoListFirst(url,e) {
      console.log(url)
      this.baseInfo.pVideoUrl = url
      window.event ? (window.event.cancelBubble = true) : e.stopPropagation();
      this.$refs.editMenu.dialogFormV(this.baseInfo);
    },
    handleVideoList(item,e) {
      window.event ? (window.event.cancelBubble = true) : e.stopPropagation();
      this.$refs.editMenuList.dialogFormV(item);
    },
  },
};
</script>

<style src='./style.scss' rel="stylesheet/scss" lang="scss" scoped> </style>
<style lang="scss">
 .el-popover{
    line-height: 22px;
    color: #616a72;
  }
.designHomeModular .el-dialog{
  padding:0px;
  margin-top: 120px !important;
  background: transparent;
  .close_ico{
      background: #fff;
      position: fixed;
      right: 50px;
      top: 50px;
      width: 30px;
      height: 30px;
      border-radius: 30px;
      border:solid 1px rgba(0,0,0,0.5);
    }
  img{
    display: block;
  }
}
.designHomeModular .swiper-pagination-bullet{
  margin: 0 4px;
}
.designHomeModular .el-dialog__header{
  display: none;
}
.uiSwiper, .uiScrollSwiper{
  display: flex;
  justify-content: center;
  align-items: center;
  .swiper-ui-pagination, .swiper-ui-scroll-pagination{ 
    margin: 0 20px;
    .swiper-pagination-bullet{
      background: #636a70 !important;
      width: 12px;
      height: 12px;
    }
    .swiper-pagination-bullet-active{
      background: #FF3366 !important;
    }
  }
  .swiper-ui-button-next, .swiper-ui-scroll-button-next{
    position: relative;
    cursor: pointer;
    width: 31px;
    height: 31px;
    border-radius: 31px;
    background: #FFFFFF;
    box-shadow: 0 0 8px 0 rgba(22,37,73,0.11);
    &::after{
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      border-radius: 100%;
      background: url('./images/icon_rit.png') center center no-repeat;
      background-size: 10px 10px;
    }
  }
  .swiper-ui-button-prev, .swiper-ui-scroll-button-prev{
    position: relative;
    cursor: pointer;
    width: 31px;
    height: 31px;
    border-radius: 31px;
    background: #FFFFFF;
    box-shadow: 0 0 8px 0 rgba(22,37,73,0.11);
    &::after{
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      border-radius: 100%;
      background: url('./images/icon_lt.png') center center no-repeat;
      background-size: 10px 10px;
    }
  }
  .swiper-ui-disabled-class{
    &::after{
      opacity: 0.3;
    }
  }
}
.uiScrollSwiper{
  .swiper-pagination-bullet{
    width: 8px !important;
    height: 8px !important;
  }
}
@media screen and (min-width: 1480px) {
  .designHomeModular .srcBox .row .col .blc div{
    margin-bottom:4px !important;
     width: 125px !important;
  }  
}  
@media screen and (min-width: 1580px) {
  .designHomeModular .srcBox .row .col .blc div{
    margin-bottom:6px !important;
    width: 135px !important;
  }  
} 
@media screen and (min-width: 1660px) {
  .designHomeModular .srcBox .row .col .blc div{
    margin-bottom:8px !important;
    width: 140px !important;
  }  
} 
@media screen and (min-width: 1760px) {
  .designHomeModular .srcBox .row .col .blc div{
    margin-bottom:11px !important;
    width: 155px !important;
  }  
}  
</style>
